import axios from 'axios'

const CARRIER_FORM_ID = '6f4af1b4-d050-455e-b506-cd978de8c166'
const PORTAL_ID = '5041527'
const carrierUrl = `https://api.hsforms.com/submissions/v3/integration/submit/${PORTAL_ID}/${CARRIER_FORM_ID}`

export function submitHubspotForm(data) {
  return axios.post(carrierUrl, data)
}
